// Mock data para SACER Servicios Eléctricos

export const servicios = [
  {
    id: 1,
    titulo: 'Particulares',
    descripcion: 'Servicios eléctricos especializados para hogares y residencias',
    icono: 'Home',
    detalles: [
      'Instalaciones eléctricas residenciales',
      'Mantenimiento preventivo y correctivo',
      'Certificación de instalaciones',
      'Actualización de sistemas eléctricos',
      'Iluminación LED y ahorro energético'
    ]
  },
  {
    id: 2,
    titulo: 'Instituciones',
    descripcion: 'Soluciones eléctricas para instituciones públicas y educativas',
    icono: 'Building2',
    detalles: [
      'Proyectos eléctricos institucionales',
      'Sistemas de respaldo de energía',
      'Iluminación de espacios públicos',
      'Mantenimiento de infraestructura eléctrica',
      'Cumplimiento normativo SEC'
    ]
  },
  {
    id: 3,
    titulo: 'Comercial o Retail',
    descripcion: 'Servicios eléctricos para negocios y establecimientos comerciales',
    icono: 'Store',
    detalles: [
      'Instalaciones eléctricas comerciales',
      'Sistemas de iluminación comercial',
      'Proyectos de retail y tiendas',
      'Mantenimiento preventivo',
      'Eficiencia energética'
    ]
  }
];

export const proyectos = [
  {
    id: 1,
    nombre: 'Instalación Eléctrica Residencial Moderna',
    categoria: 'Residencial',
    descripcion: 'Instalación completa de sistema eléctrico con tecnología LED y domótica',
    imagen: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2FsJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc4MTU4MDUxNnww&ixlib=rb-4.1.0&q=85',
    fecha: '2025'
  },
  {
    id: 2,
    nombre: 'Edificio Corporativo - Sistema Integral',
    categoria: 'Comercial',
    descripcion: 'Proyecto completo de instalación eléctrica y automatización para edificio de oficinas',
    imagen: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgxNTgwNTE3fDA&ixlib=rb-4.1.0&q=85',
    fecha: '2024'
  },
  {
    id: 3,
    nombre: 'Iluminación LED Comercial',
    categoria: 'Retail',
    descripcion: 'Modernización de sistema de iluminación con tecnología LED de alta eficiencia',
    imagen: 'https://images.unsplash.com/photo-1515948725-edac7b5bb0fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsaWdodGluZ3xlbnwwfHx8fDE3ODE1ODA1MTZ8MA&ixlib=rb-4.1.0&q=85',
    fecha: '2024'
  },
  {
    id: 4,
    nombre: 'Paneles Solares - Energía Renovable',
    categoria: 'Industrial',
    descripcion: 'Instalación de sistema fotovoltaico de 50kW con conexión a red',
    imagen: 'https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVsc3xlbnwwfHx8fDE3ODE1ODA1MjZ8MA&ixlib=rb-4.1.0&q=85',
    fecha: '2024'
  },
  {
    id: 5,
    nombre: 'Centro Comercial - Instalación Completa',
    categoria: 'Comercial',
    descripcion: 'Proyecto integral de instalación eléctrica para centro comercial',
    imagen: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgxNTgwNTE3fDA&ixlib=rb-4.1.0&q=85',
    fecha: '2024'
  },
  {
    id: 6,
    nombre: 'Tableros Eléctricos Industriales',
    categoria: 'Industrial',
    descripcion: 'Fabricación e instalación de tableros eléctricos para planta industrial',
    imagen: 'https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc4MTU4MDUxNnww&ixlib=rb-4.1.0&q=85',
    fecha: '2025'
  }
];

export const testimonios = [
  {
    id: 1,
    nombre: 'Carlos Mendoza',
    empresa: 'Edificio Residencial Los Pinos',
    cargo: 'Administrador',
    testimonio: 'Excelente servicio, profesionales altamente capacitados. La instalación eléctrica quedó impecable y cumplieron con todos los plazos acordados.',
    rating: 5
  },
  {
    id: 2,
    nombre: 'María Fernández',
    empresa: 'Retail Store Fashion',
    cargo: 'Gerente General',
    testimonio: 'SACER realizó la instalación eléctrica completa de nuestra tienda. Muy profesionales, rápidos y con excelente atención al detalle.',
    rating: 5
  },
  {
    id: 3,
    nombre: 'Roberto Silva',
    empresa: 'Colegio San Andrés',
    cargo: 'Director',
    testimonio: 'Confiamos en SACER para el mantenimiento eléctrico de nuestra institución. Siempre responden rápido y solucionan cualquier problema de manera eficiente.',
    rating: 5
  }
];

export const certificaciones = [
  {
    id: 1,
    nombre: 'Certificaciones y Competencias',
    descripcion: '',
    icono: 'Award'
  },
  {
    id: 2,
    nombre: 'Gestión de Calidad',
    descripcion: '',
    icono: 'Shield'
  },
  {
    id: 3,
    nombre: '15+ Años Experiencia',
    descripcion: '',
    icono: 'Trophy'
  },
  {
    id: 4,
    nombre: '100% Proyectos Completados Existosamente',
    descripcion: '',
    icono: 'CheckCircle'
  }
];

export const areasServicio = {
  electrica: {
    titulo: 'Área Eléctrica',
    descripcion: 'Especialistas en instalaciones eléctricas',
    imagen: 'https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmd8ZW58MHx8fHwxNzgxNTgwNDU5fDA&ixlib=rb-4.1.0&q=85',
    servicios: [
      'Instalaciones eléctricas residenciales, comerciales e industriales',
      'Proyectos eléctricos y tramitación SEC',
      'Mantención preventiva y correctiva',
      'Certificación de instalaciones eléctricas',
      'Empalmes y conexiones',
      'Canalizaciones',
      'Tableros eléctricos',
      'Sistemas de puesta a tierra',
      'Soporte eléctrico operacional'
    ]
  },
  construccion: {
    titulo: 'Área Construcción',
    descripcion: 'Proyectos de construcción con altos estándares de calidad',
    imagen: 'https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3ODE1ODA0ODZ8MA&ixlib=rb-4.1.0&q=85',
    servicios: [
      'Remodelaciones',
      'Ampliaciones',
      'Obras civiles menores',
      'Reparaciones',
      'Demoliciones controladas',
      'Estructuras livianas',
      'Gestión y administración de proyectos',
      'Cumplimiento normativo y permisos'
    ]
  },
  mantencion: {
    titulo: 'Área Mantención y Servicios',
    descripcion: 'Mantenimiento integral para garantizar el funcionamiento óptimo',
    imagen: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwbWFpbnRlbmFuY2V8ZW58MHx8fHwxNzgxNTgwNDg2fDA&ixlib=rb-4.1.0&q=85',
    servicios: [
      'Mantenimiento preventivo programado',
      'Mantenimiento correctivo de emergencia',
      'Servicios industriales',
      'Apoyo operacional',
      'Soporte terreno',
      'Servicios tecnicos complementarios',
      'Actualización de sistemas obsoletos',
      'Servicio técnico 24/7',
      'Contratos de mantenimiento',
      'Planes personalizados según necesidad'
    ]
  }
};

export const equipoInfo = {
  somos: 'SACER busca desarrollar soluciones técnicas basadas en experiencia real de terreno, integrando distintas especialidades para responder de manera eficiente, segura y adaptable a los requerimientos de cada proyecto. La empresa nace con la visión de reunir capacidades provenientes de áreas eléctricas, construcción, mantención y soporte operacional, incorporando personas con experiencia práctica, formación técnica y conocimientos adquiridos directamente en terreno.',
  capacidades: 'SACER busca fortalecer redes de apoyo técnico y operacional mediante la integración de especialistas, técnicos y apoyo de ingeniería, permitiendo conformar equipos de trabajo funcionales y adaptables según las necesidades de cada servicio. El objetivo es entregar soluciones reales y eficientes a clientes del área domiciliaria, comercial e industrial, priorizando la coordinación entre especialidades, la correcta planificación y una ejecución segura y ordenada.',
  enfoque: 'La empresa mantiene un enfoque orientado a desarrollar trabajos con una ejecución lo menos invasiva posible, apoyando la continuidad operacional y buscando minimizar impactos durante la ejecución de los servicios. SACER busca integrar experiencia práctica de terreno con apoyo técnico especializado, permitiendo responder de manera flexible a distintos tipos de requerimientos, mantenciones, servicios spot, proyectos y licitaciones.',
  innovacion: 'La empresa mantiene una visión flexible y progresiva, abierta a la incorporación de nuevas tecnologías, métodos de trabajo, herramientas digitales y mejoras operacionales que permitan fortalecer continuamente la eficiencia, seguridad y capacidad de respuesta de sus servicios. El desarrollo de procesos documentales, automatización de registros y mejora continua forman parte de la visión de crecimiento estructurado proyectada para la empresa',
  personas: 'SACER valora el desarrollo humano, el respeto y la integración de personas provenientes de distintas áreas técnicas y operacionales, promoviendo oportunidades de participación y desarrollo profesional basadas en capacidades, compromiso y experiencia. La empresa mantiene una visión inclusiva orientada a integrar equipos de trabajo diversos, reconociendo el valor del aporte técnico y profesional tanto de hombres como mujeres dentro del desarrollo de sus distintas áreas de servicio.',
  crecimiento: 'SACER proyecta un crecimiento gradual, ordenado y sostenible en el tiempo, fortaleciendo sus capacidades mediante experiencia acumulada, incorporación de nuevas especialidades y desarrollo continuo de redes de apoyo técnico y operacional. La visión de la empresa está orientada a consolidar una estructura adaptable y técnicamente capaz de evolucionar progresivamente junto a las necesidades de sus clientes y servicios.',
  valores: [
    { nombre: 'Calidad', descripcion: 'Compromiso con la excelencia en cada proyecto' },
    { nombre: 'Seguridad', descripcion: 'Prioridad absoluta en todas nuestras operaciones' },
    { nombre: 'Profesionalismo', descripcion: 'Personal altamente capacitado y certificado' },
    { nombre: 'Innovación', descripcion: 'Tecnología de punta y soluciones eficientes' },
    { nombre: 'Confiabilidad', descripcion: 'Cumplimiento de plazos y compromisos' }
  ]
};